import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {SnackBarComponent} from '../../snackbar/snackbar.component';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-imageupload',
  templateUrl: './imageupload.component.html',
  styleUrls: ['./imageupload.component.scss']
})
export class ImageuploadComponent implements AfterViewInit {

  @ViewChild('camerainput') cameraInput?: ElementRef;
  @ViewChild('avatar') avatar!: ElementRef;
  @Input() buttonColor = 'accent';
  @Input() imageUrl = '';
  @Output() uploadedEvent: EventEmitter<any> = new EventEmitter<any>();

  public gotImage = false;
  private clearImage = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

  constructor(
      private snackBar: MatSnackBar,
    ) {
  }

  ngAfterViewInit(): void {
    this.avatar.nativeElement.src = this.avatar && this.imageUrl ? this.imageUrl : this.clearImage;
  }

  clearBrokenAvatar(): void {
    if (this.avatar) {
      this.gotImage = false;
      this.avatar.nativeElement.src = this.clearImage;
    }
  }

  takePicture(): void {
    this.cameraInput?.nativeElement.click();
  }

  changePhoto($event: any): void {
    if ($event && $event.target.files[0] && $event.target.files[0].type.indexOf('image') < 0) {
      this.snackBar.openFromComponent(SnackBarComponent, {data: 'You did not select a valid image file'});
      return;
    }
    const imageType = $event.target.files[0].type;
    const reader = new FileReader();
    reader.onload = (event) => {
      this.uploadImage(reader.result, imageType);
    };
    reader.readAsArrayBuffer($event.target.files[0]);
  }

  private arrayBufferToObjectUrl(arrayBuffer: any, mimeType = 'image/jpeg'): string {
    const blob = new Blob([arrayBuffer], { type: mimeType });
    return URL.createObjectURL(blob);
  }

  private uploadImage(img: any, imageType: string): void {
    if (this.avatar) {
      this.avatar.nativeElement.src = this.arrayBufferToObjectUrl(img, imageType);
      this.gotImage = true;
    }
    this.uploadedEvent.emit(img);
  }

  clearAvatar(): void {
    if (this.avatar) {
      this.gotImage = false;
      this.avatar.nativeElement.src = this.clearImage;
    }
    this.uploadedEvent.emit(null);
  }

}
